export const convertToEnglishNumbers = (persianNumber) => {
    return persianNumber.replace(/[۰-۹]/g, (digit) =>
        "0123456789"[ "۰۱۲۳۴۵۶۷۸۹".indexOf(digit) ]
    );
};
